export enum TipoLargoLineaEnum {
  LARGE = 'large',
  FULL = 'full',
  MEDIUM = 'medium',
  SMALL = 'small',
}
